import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IPackageWarehouseState } from './package-warehouse';

const packageWarehouseStateSelector = createFeatureSelector<IPackageWarehouseState>('packageWarehouse');

export const selectPacchiInGiacenza = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responsePacchiInGiacenza
);

export const selectMovimentazioneList = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseMovimentazione
);

export const selectEsportaFileXls = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseEsportaXls
);

export const selectEsportaFileMail = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseEsportaMail
);

export const selectBoxToCheck = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseVerificaBox
)

export const selectBeniContoDeposito = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseBeniContoDeposito
);

export const selectScatolaNonDisponibile = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseScatolaNonDisponibile
);

export const selectChangeStatusVerifica = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseChangeStatusVerifica
);

export const selectExistsScatolaFlyer = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseExistsScatolaFlyer
);

export const selectChiudiScatola = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseChiudiScatola
);

export const selectChiusuraScatoleBxl = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseChiusuraScatoleBxl
);

export const selectStoricoContoDeposito = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseStoricoContoDeposito
);

export const selectStoricoAnnualeContoDesposito = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseStoricoAnnualeContoDeposito
);

export const selectMovimentazioneCreateEvent = createSelector(
  packageWarehouseStateSelector,
  (state: IPackageWarehouseState) => state.responseMovimentazioneCreateEvent
);




